import { render } from "./PrestationHoldingTable.vue?vue&type=template&id=d6f1f794"
import script from "./PrestationHoldingTable.vue?vue&type=script&lang=js"
export * from "./PrestationHoldingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__